module.exports = __webpack_public_path__ + "static/media/AquamarinePng.2f636398.png";